/**
 * Pointer-lock mouse look. Click the canvas to capture; Esc releases. Deltas accumulate between
 * frames and are consumed by the camera at render rate (camera is presentation — design C2).
 * The mouse turns the CAMERA; the character orients to movement (Astro paradigm).
 */
export class MouseLookSource {
  private dx = 0;
  private dy = 0;
  private locked = false;

  attach(canvas: HTMLElement): () => void {
    const onClick = () => {
      if (!this.locked) canvas.requestPointerLock();
    };
    const onLockChange = () => {
      this.locked = document.pointerLockElement === canvas;
    };
    const onMove = (e: MouseEvent) => {
      if (!this.locked) return;
      this.dx += e.movementX;
      this.dy += e.movementY;
    };
    canvas.addEventListener('click', onClick);
    document.addEventListener('pointerlockchange', onLockChange);
    document.addEventListener('mousemove', onMove);
    return () => {
      canvas.removeEventListener('click', onClick);
      document.removeEventListener('pointerlockchange', onLockChange);
      document.removeEventListener('mousemove', onMove);
      if (this.locked) document.exitPointerLock();
    };
  }

  /** Pixel deltas since last consume. */
  consumeDeltas(): { dx: number; dy: number } {
    const d = { dx: this.dx, dy: this.dy };
    this.dx = 0;
    this.dy = 0;
    return d;
  }

  isLocked(): boolean {
    return this.locked;
  }
}
